// 2.5 — the slow-turn caption on the typing bubble. Appears once the in-flight
// turn passes the threshold; the dots keep going and nothing else changes.
// Rendered inside the existing typing bubble so it inherits that bubble's status
// semantics rather than adding a second announcement.

import { SLOW_TURN_CAPTION } from './constants';
import styles from './ConversationalForms.module.css';
import { useConversationalForms } from './FormsContext';

const SlowTurnCaption = () => {
    const { active, state } = useConversationalForms();
    if (!active || !state.slowTurn) return null;
    return <div className={styles.slowCaption}>{SLOW_TURN_CAPTION}</div>;
};

export default SlowTurnCaption;
